import { useDialog } from 'components/_hooks/useComponents/useDialog'
import React, { useEffect, useState, useMemo } from 'react'
import {isMobileOnly,isTablet} from 'react-device-detect';

import { cn, round2Places } from 'utils'
import HeaderNotification from '../HeaderNotification/HeaderNotification'
import Notifications from '../Notifications/Notifications'

import { ButtonLink, HeaderLinkNew, Img, KlLink } from 'components/_shared'
import ReactTooltip from 'react-tooltip'
import { getIsAdmin, getIsOrganizer, getIsPlayer, getPlayerRank, getRoleName } from 'store/types/user-types'
import { ContainerName, useAppSelector, useAppUser, useGetImageSize } from 'components/_hooks'
import ProfileDropDown from './_shared/ProfileDropDown'


import styles from './Header.module.scss'
import rightMenuStyles from 'components/Layout/partials/RightMenu/RightMenu.module.scss'
import MobileMenuNew from './_shared/MobileMenuNew'
import UnreadChatsModal from '../UnreadChatsModal/UnreadChatsModal'
import { makeGetUnreadMessagesCount } from 'store/chat/chat-message/chat-message-selectors'
import { useDispatch } from 'react-redux'
import { loadUnreadChats } from 'store/chat/chat-message/chat-message-logic'
import { loadPlayerBattlesAndLoyaltyPoints } from 'store/logic/player-battle-and-loyaltypoint-logic'
import { makeGetPlayerBattlesAndLoyaltyPoints } from 'store/selectors/player-battle-and-loyaltypoint-selector'
import { loadPlayerProfileByUserId } from 'store/logic/user-logic'
import { usePlayerProfile } from 'components/_hooks/useModels/usePlayerProfile'
import { loadOrganizerTournamentAndMembersAndIncome } from 'store/logic/organizer-tournament-members-income-logic'
import { makeGetOrganizerTournamentAndMembersAndIncome, makeGetOrganizerTournamentAndMembersAndIncomeLoaded } from 'store/selectors/organizer-tournament-members-income-selector'
interface OwnProps {
  onFriendsClick: () => void
}

const HeaderNew = ({ onFriendsClick }: OwnProps) => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const [isOpened, setIsOpened] = useState(false)
  const [isNotificationsOpened, setIsNotificationsOpened] = useState(false)

  const user = useAppUser()
  const isUserLoggedIn = !!user
  const isOrganizer = getIsOrganizer(user?.Role)
  const isPlayer = getIsPlayer(user?.Role)
  const isAdmin = getIsAdmin(user?.Role)
  const playerRecord = useAppSelector(makeGetPlayerBattlesAndLoyaltyPoints)
  const playerProfile = usePlayerProfile(user?.Id)
  const organizerRecord = useAppSelector(makeGetOrganizerTournamentAndMembersAndIncome)
  const isLoadedOrganizerRecord = useAppSelector(makeGetOrganizerTournamentAndMembersAndIncomeLoaded)
  const getProfileContainerSize = useGetImageSize(ContainerName.AvatarsNormal)
  const handleFriendsClick = () => {
    onFriendsClick()
  }

  const loadPlayerRecord = async () => {
    user && dispatch(loadPlayerBattlesAndLoyaltyPoints(user.Id))
  }

  const loadOrganizerRecord = async () => {
    const isReloadOrganizerRecord = isLoadedOrganizerRecord === undefined || isLoadedOrganizerRecord === false ? true : false
    if (user && isOrganizer && isReloadOrganizerRecord) {
      dispatch(loadOrganizerTournamentAndMembersAndIncome(user.Id))
    }
  }

  const handleUnreadChatsClick = () => {
    openUnreadChatsModal()
  }

  const handleMobileMenuClick = () => {
    setIsOpened(!isOpened)
  }

  useEffect(() => {
    loadPlayerRecord()
    loadPlayerProfile()
  }, [user])

  useEffect(() => {
    loadOrganizerRecord()
  }, [user, isLoadedOrganizerRecord])

  useEffect(() => {
    document.body.style.overflowY = isOpened ? 'hidden' : 'auto'
    return () => {
      document.body.style.overflowY = 'auto'
    }
  }, [isOpened])

  useEffect(() => {
    if (user) {
      dispatch(loadUnreadChats())
    }
  }, [user, dispatch])
  const getUnreadMessagesCount = useMemo(makeGetUnreadMessagesCount, [])
  const unreadMessagesCount = useAppSelector(getUnreadMessagesCount)

  const [unreadChatsModal, openUnreadChatsModal] = useDialog(closeDialog => (
    <UnreadChatsModal
      closeDialog={closeDialog}
    />
  ))
  const loadPlayerProfile = async () => {
    if (user && isPlayer) {
      dispatch(loadPlayerProfileByUserId(user.Id))
    }
  }
  return (
    <>
      <MobileMenuNew
        onMenuClick={handleMobileMenuClick}
        isOpened={isOpened}
        isOrganizer={isOrganizer}
        isUserLoggedIn={isUserLoggedIn}
        onFriendsClick={handleFriendsClick}
        unreadMessagesCount={unreadMessagesCount}
        openUnreadMessagesModal={openUnreadChatsModal}
        isNotificationsOpened={isNotificationsOpened}
        setIsNotificationsOpened={setIsNotificationsOpened}
        page={page}
        setPage={setPage}
      />
      <header className={cn(styles.header, isOpened && styles.header__opened, !isUserLoggedIn && styles.header__guest)}>
        <div className="container-fluid h-100 p-0">
          <div className="row justify-content-lg-between align-items-lg-center justify-content-center align-items-start h-lg-100">
            <KlLink to="/" className={cn('col-auto', styles.header__logo)} />
            <nav className={cn('col-lg', 'col-md-12', styles.header__navigation)}>
              <div
                className={cn(
                  'row flex-column flex-lg-row justify-content-lg-end justify-content-start',
                  isUserLoggedIn && 'align-items-lg-center align-items-start'
                )}
              >
                
                {(isMobileOnly || isTablet ) ? <>
                  <div className="row w-100">
                    <div className="col-md-6 col-sm-6 col-xs-6 col-5">
                      <KlLink to="/faq/get-in-touch" className={`${styles.header__link} ${styles.header__newlink} ${styles.contactUsLink}`}>
                        <span className={`${styles.iconMenu}`}></span>
                        <span> Contact Us </span>
                      </KlLink>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6 col-5">
                      <KlLink to="/faq/video-tutorials" className={`${styles.header__link} ${styles.header__newlink} ${styles.tutorialsLink}`}>
                        Tutorials
                      </KlLink>
                    </div>
                  </div>
                  
                  <div className="row w-100">
                    <div className="col-md-6 col-sm-6 col-xs-6 col-5">
                      <KlLink to="/faq" className={`${styles.header__link} ${styles.header__newlink} ${styles.infoLink}`}>
                        Info
                      </KlLink>
                    </div>
                    <div className="col-md-6 col-sm-6 col-xs-6 col-5">
                      <KlLink to="/victory-road-list" className={`${styles.header__link} ${styles.header__newlink} ${styles.pastEventsLink}`}>
                        Past Events
                      </KlLink>
                    </div>
                  </div>
                </>:
                <div className="row mr-2">
                  <KlLink to="/faq/get-in-touch" className={`${styles.header__link} ${styles.header__newlink}`}>
                    <span> Contact Us </span>
                  </KlLink>
                  <KlLink to="/faq/video-tutorials" className={`${styles.header__link} ${styles.header__newlink}`}>
                    Tutorials
                  </KlLink>
                  <KlLink to="/faq" className={`${styles.header__link} ${styles.header__newlink}`}>
                    Info
                  </KlLink>
                  <KlLink to="/victory-road-list" className={`${styles.header__link} ${styles.header__newlink}`}>
                    Past Events
                  </KlLink>
                </div>}
                {!isUserLoggedIn ? (
                  <>
                    <div className={cn('col-auto', styles.header__section, styles.header__section__public)}>
                      <div className="row">
                        <HeaderLinkNew color="white" to="/login">
                          LOGIN
                        </HeaderLinkNew>
                        <HeaderLinkNew filled color="blue" to="/register">
                          SIGN UP
                        </HeaderLinkNew>
                      </div>
                    </div>
                    <div className={cn('col-auto', rightMenuStyles.header__section__friends)}>
                      <div className="row">
                        <HeaderNotification onClick={handleFriendsClick} className={styles.header__notification__friends} />
                      </div>
                    </div>
                    <ProfileDropDown />
                  </>
                ) : (
                    <>
                      {isOrganizer && (
                        <div className={cn('col-auto p-0', styles.header__section)}>
                          <ButtonLink to="/create-tournament/" className={styles.header__createChallenge} color="green" filled>
                            Create tourney
                        </ButtonLink>
                        </div>
                      )
                      }
                      <div className={cn('col-auto', styles.header__section)}>
                        {isOrganizer && (
                          <div className="row">
                            <KlLink to="#" className={styles.header__info}>
                              <div className={cn(styles.header__infoBackground, styles.header__infoBackground__tournaments)} data-tip="Completed<br />Tournaments" data-for="cup" />
                              <div className={styles.header__infoText}>{organizerRecord?.TotalTournament || 0}</div>
                              <ReactTooltip id="cup" place="bottom" multiline />
                            </KlLink>
                            <KlLink to="#" className={styles.header__info}>
                              <div className={cn(styles.header__infoBackground, styles.header__infoBackground__earnmoney)} data-tip="Available<br />Funds" data-for="money" />
                              <div className={styles.header__infoText}>{round2Places(organizerRecord?.Income, 2) || 0}</div>
                              <ReactTooltip id="money" place="bottom" multiline />
                            </KlLink>
                            <KlLink to="#" className={styles.header__info}>
                              <div className={cn(styles.header__infoBackground, styles.header__infoBackground__members)} data-tip="Members<br />Online" data-for="people" />
                              <div className={styles.header__infoText}>{organizerRecord?.OnlineMembers || 0}</div>
                              <ReactTooltip id="people" place="bottom" multiline />
                            </KlLink>
                          </div>
                        )}
                        {isPlayer && (
                          <div className="row">
                            <KlLink to="/player-transactions" className={styles.header__info}>
                              <div className={styles.header__infoBackground__gamepad} data-tip="Tournaments<br />Played" data-for="gamepad" />
                              <div className={styles.header__infoText}>{playerRecord?.TotalBattles || 0}</div>
                              <ReactTooltip id="gamepad" place="bottom" multiline />
                            </KlLink>
                            <KlLink to="/player-transactions" className={styles.header__info}>
                              <div className={cn(styles.header__infoBackground, styles.header__infoBackground__likes)} data-tip="Loyalty<br />Points" data-for="likes" />
                              <div className={styles.header__infoText}>{playerRecord?.LoyaltyPoints || 0}</div>
                              <ReactTooltip id="likes" place="bottom" multiline />
                            </KlLink>
                          </div>
                        )}
                      </div>

                      <div className={cn('col-auto', styles.header__section)}>
                        <div className="row">
                          <HeaderNotification
                            onClick={handleUnreadChatsClick}
                            className={styles.header__notification__email}
                            displayValue
                            value={unreadMessagesCount}
                          />
                        </div>
                      </div>
                      <div className={cn('col-auto', styles.header__section)}>
                        <div className="row">
                          <Notifications
                            isOpened={isNotificationsOpened}
                            setIsOpened={setIsNotificationsOpened}
                            page={page}
                            setPage={setPage}
                            notificationIconType="header"
                          />
                        </div>
                      </div>
                      {isPlayer && (
                        <div className={cn('col-auto', styles.header__section)}>
                          <div className="row">
                            <HeaderNotification
                              onClick={() => {
                                window.location.href = '/cart'
                              }}
                              className={styles.header__notification__cart}
                            />
                          </div>
                        </div>
                      )}
                      <div className={cn('col-auto', styles.header__section, rightMenuStyles.header__section__friends)}>
                        <div className="row">
                          <HeaderNotification onClick={handleFriendsClick} className={styles.header__notification__friends} />
                        </div>
                      </div>
                      <input className={styles.header__checkbox} id="header-checkbox" type="checkbox" name="header" />
                      <div className={cn('col-lg-auto col-12', styles.header__section)}>
                        <div className={cn('row h-100 align-items-center', styles.header__profileInfo)}>
                          <Img parentContainerSize={getProfileContainerSize} className={styles.header__profilePicture} imageId={user?.AvatarId} placeholder="dark" />
                          <div className={styles.header__profileName}>
                            {user &&
                              <>
                                {!isOrganizer && user.Username}
                                {isOrganizer && user.Organizationname}
                              </>
                            }
                            <br />
                            <span className={styles.header__profileRank}>
                              {(isOrganizer || isAdmin) && getRoleName(user.Role)}
                              {(playerProfile && isPlayer) && getPlayerRank(playerProfile.TotalExperience)}
                            </span>
                          </div>
                          <label className={styles.header__showProfile} htmlFor="header-checkbox" />
                        </div>
                        <ProfileDropDown />
                      </div>
                    </>
                  )}
              </div>
            </nav>
          </div>
        </div>
      </header>
      {unreadChatsModal}
    </>
  )
}

export default HeaderNew
